import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['selectedAmount', 'allLocked']
  static values = { selectedAmount: Number, allLocked: Boolean }
  lockButton = this.allLockedTargets[0]
  unlockButton = this.allLockedTargets[1]

  selectedAmountValueChanged() {
    this.selectedAmountTarget.innerText = this.selectedAmountValue
    this.selectedAmountValue ? this.show(this.element) : this.hide(this.element)
  }

  allLockedValueChanged() {
    if (this.allLockedValue) {
      this.show(this.unlockButton)
      this.hide(this.lockButton)
    } else {
      this.show(this.lockButton)
      this.hide(this.unlockButton)
    }
  }

  show(element) {
    element.classList.add('inline-flex')
    element.classList.remove('hidden')
  }

  hide(element) {
    element.classList.remove('inline-flex')
    element.classList.add('hidden')
  }

  closeToolbar() {
    this.hide(this.element)
  }
}
